import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.lookit.confidencebadge');
import { Input } from '@angular/core';

const LABELS: Record<string, string> = {
    exact: '동일 상품 가능성 높음',
    wholesale: '같은 도매택 상품 추정',
    similar: '유사 디자인',
    needs_check: '확인 필요'
};

@Component({
    selector: 'wiz-component-lookit-confidencebadge',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.lookit.confidencebadge/view.scss */
:host {
  display: inline-flex;
  min-width: 0;
}

.lookit-confidence-badge {
  display: inline-flex;
  max-width: 100%;
  min-height: 28px;
  align-items: center;
  gap: 6px;
  border: 1px solid var(--lookit-border-medium);
  border-radius: var(--lookit-radius-pill);
  background: var(--lookit-color-surface-muted);
  color: var(--lookit-color-text-soft);
  padding: 0 9px;
  font-size: var(--lookit-font-size-xs);
  font-weight: var(--lookit-font-weight-black);
  line-height: 1.15;
}

.lookit-confidence-badge__dot {
  width: 6px;
  height: 6px;
  flex: 0 0 auto;
  border-radius: var(--lookit-radius-pill);
  background: currentColor;
}

.lookit-confidence-badge__label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lookit-confidence-badge__score {
  flex: 0 0 auto;
  color: var(--lookit-color-text-muted);
}

.lookit-confidence-badge.is-exact {
  border-color: color-mix(in srgb, var(--lookit-color-price-drop) 40%, var(--lookit-color-surface));
  background: var(--lookit-color-price-drop-soft);
  color: var(--lookit-color-price-drop);
}

.lookit-confidence-badge.is-wholesale {
  border-color: color-mix(in srgb, var(--lookit-color-accent) 50%, var(--lookit-color-surface));
  background: var(--lookit-color-accent-soft);
  color: var(--lookit-color-accent-strong);
}

.lookit-confidence-badge.is-similar {
  border-color: color-mix(in srgb, var(--lookit-color-olive) 42%, var(--lookit-color-surface));
  background: var(--lookit-color-olive-soft);
  color: var(--lookit-color-olive);
}`],
})
export class ComponentLookitConfidencebadgeComponent {
    @Input() type: 'exact' | 'wholesale' | 'similar' | 'needs_check' | string = 'exact';
    @Input() label: string = '';
    @Input() score: number | string | null = null;

    public get resolvedLabel(): string {
        if (this.label) return this.label;
        return LABELS[this.type] || LABELS.needs_check;
    }

    public get scoreLabel(): string {
        if (this.score === null || this.score === undefined || this.score === '') return '';
        if (typeof this.score === 'number') {
            const value = this.score <= 1 ? Math.round(this.score * 100) : Math.round(this.score);
            return `${value}%`;
        }
        return `${this.score}`;
    }
}

export default ComponentLookitConfidencebadgeComponent;